export default function (dollarAmount){
    var priceInt = parseInt(dollarAmount = Math.abs(+dollarAmount || 0).toFixed(2)) + "",
        priceLength = 0,
        numberOfCommas = 0;

    if(isNaN(dollarAmount)||dollarAmount<0)
        return null;
    priceLength = priceInt.length;
    numberOfCommas = priceLength > 3 ? priceLength % 3 : 0;
    return (numberOfCommas ? priceInt.substr(0, numberOfCommas) + "," : "")
            + priceInt.substr(numberOfCommas).replace(/(\d{3})(?=\d)/g, "$1" + ",")
            + "." + Math.abs(dollarAmount - priceInt).toFixed(2).slice(2);
};
